/**
 * Un mixin composite entre makeRules et makeValueData
 */
export default {
    methods: {
        clear(field) {
            delete this.validation.fields[field];
        },
        notify(field) {
            this.clear(field);
            this.changed();
        }
    }
}
